import React from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

function getInitialColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f43f5e', '#f97316', '#eab308', '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6'];
  return colors[Math.abs(hash) % colors.length];
}

const AttendeeListWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';

  if (!state) return null;

  const { attendees } = state;

  if (!attendees.length) {
    return (
      <div className={`flex items-center justify-center h-full text-sm ${
        isDark ? 'text-white/30' : 'text-slate-400'
      }`}>
        No attendees
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-4 p-4 overflow-auto h-full content-start">
      {attendees.map((attendee) => (
        <div key={attendee.id} className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0"
            style={{ backgroundColor: getInitialColor(attendee.name) }}
          >
            {attendee.name.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <div className={`text-sm font-semibold truncate ${
              isDark ? 'text-white/90' : 'text-slate-800'
            }`}>
              {attendee.name}
            </div>
            <div className={`text-xs truncate ${
              isDark ? 'text-white/40' : 'text-slate-400'
            }`}>
              {[attendee.role, attendee.organization].filter(Boolean).join(' · ')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttendeeListWidget;
